import React, { useState } from 'react';
import { Container, Header, Content, Text, Icon, Spinner, View, Left, Right, Body, Button, Title, Footer, Tabs, Tab } from 'native-base';
import { StyleSheet, KeyboardAvoidingView, Linking, Platform, Dimensions } from 'react-native';
import Pdf from '../../components/pdf';
import downloader from '../../components/downloader';
import * as Print from 'expo-print';

import CalCalDataApi from '../../api/CalCalDataApi';
import Alert from '../../components/alert';
import OnPageHelp from '../../components/onPageHelp';

//shows in details for a submitted year
//HMRC Receipt. Total owed. Answers. SA302 + download PDF
export default function Sa302({ year, navigation, jwt, details }) {
	const { width, height } = Dimensions.get('window');
	const [error, setError] = useState(null);
	const [pdf, setPdf] = useState(null);
	const [html, setHtml] = useState(null);
	const [helpUrl, setHelpUrl] = useState(null);

	if (!pdf && !error)
		CalCalDataApi.dataLoad('reports/SA302/' + year, jwt, res => {
			if (__DEV__) console.log(res);

			if (!res.error) {
				setPdf(res.content);
				setHtml(res.html);
			} else {
				setError({ loading: 'forms', error: typeof res.error == 'text' ? res.error : res.message });
				Alert.alert('Error', typeof res.error == 'text' ? res.error : res.message);
			}
		});

	const [ansHtml, setAnsHtml] = useState(null);
	const [ansPdf, setAnsPdf] = useState(null);
	const [tab, setTab] = useState(0);
	const changedTab = ({ i, ref, from }) => {
		setTab(i);
		if (i == 1 && !ansHtml) {
			CalCalDataApi.dataLoad(`sa/${year}/submitted`, jwt, res => {
				if (!res.error) {
					setAnsPdf(res.pdf);
					setAnsHtml(res.html);
				} else {
					setError(res.error);
				}
			});
		}
	};

	const amend = () => {
		Alert.alert(
			'Amend this return?',
			`Are you sure you want to amend this tax year? Sending an amended return to HMRC is possible, but please read the notes (particularly parts about foreign income) before you decide. Once you re-open the tax year, you can make changes to your business takings and expenses if appropriate, as well as any tax forms needed.\nRe-open this year\'s tax for amendment?`,
			[
				{ text: 'See Notes', onPress: () => Linking.openURL('https://www.gov.uk/self-assessment-tax-returns/corrections') },
				{ text: 'Cancel', onPress: () => console.log('Cancel Pressed'), style: 'cancel' },
				{ text: 'OK', onPress: () => doAmend() }
			],
			{ cancelable: true }
		);
	};
	const doAmend = () => {
		CalCalDataApi.dataInsert(`sa/${year}/amend`, {}, jwt, res => {
			if (__DEV__) console.log(res);

			if (res.success) {
				Alert.alert('Amending', res.message);
				navigation.goBack();
				navigation.navigate('SaDetails', { year, recheck: 1 });
			} else {
				Alert.alert('Error', res.error);
			}
		});
	};

	return (
		<Container>
			<Header hasTabs>
				<Left>
					<Button transparent onPress={() => navigation.goBack()}>
						<Icon active name="ios-arrow-back" />
					</Button>
				</Left>
				<Body style={{ flex: 5 }}>
					<Title>Your Submission</Title>
					<Text style={styles.headerTxt}>{details.text}</Text>
				</Body>
				<Right />
			</Header>

			<Tabs locked onChangeTab={changedTab}>
				<Tab heading="Calculation" style={{ height: height - 150 }}>
					{!!pdf ? <Pdf pdfContent={pdf && 'data:application/pdf;base64,' + pdf} htmlContent={html} /> : <View style={{ flex: 1 }} />}
				</Tab>
				<Tab heading="Tax Return" style={{ height: height - 150 }}>
					{ansPdf && <Pdf pdfContent={ansPdf && 'data:application/pdf;base64,' + ansPdf} />}
				</Tab>
			</Tabs>

			<Footer style={styles.footer}>
				{!!pdf && !error && (
					<>
						<Left>
							<Button style={styles.bottomButton} onPress={() => downloader(tab == 0 ? pdf : ansPdf, tab == 0 ? 'SA302 ' + details.text : 'SA Submission ' + details.text)}>
								<Icon name="download" style={styles.bottomIcon} />
							</Button>
						</Left>
						<Body>
							<Button style={styles.bottomButton} onPress={amend}>
								<Text>Amend</Text>
							</Button>
						</Body>
						<Right>
							{Platform.OS != 'web' && (
								<Button style={styles.bottomButton} onPress={() => Print.printAsync({ uri: 'data:application/pdf;base64,' + (tab == 0 ? pdf : ansPdf) })}>
									<Icon name="print" style={styles.bottomIcon} />
								</Button>
							)}
						</Right>
					</>
				)}
			</Footer>
			<OnPageHelp fullUrl={helpUrl} />
		</Container>
	);
}

const styles = StyleSheet.create({
	headerTxt: {
		color: '#EEE'
	},
	footer: {
		//backgroundColor: '#295670',
		height: 40
	},
	bottomButton: {
		alignSelf: 'center',
		backgroundColor: 'rgba(100, 100, 120, 0.5)',
		//paddingVertical: 20,
		flex: 1,
		justifyContent: 'center'
	},
	bottomIcon: {
		//color: '#8fbcd6'
	}
});
